export enum NotificationPermissions {
    Default = 'default',
    Denied = 'denied',
    Granted = 'granted',
    Unset = '',
    Unsupported = 'unsupported',
}
